import { useContext } from 'react';
import { ProfileContext } from '../contexts/profile-context';
export var useProfile = function () {
    var context = useContext(ProfileContext);
    if (!context) {
        throw new Error('useProfile must be used within a ProfileProvider');
    }
    return context;
};
